import logo from './logo.svg'

export const theme = {
    color: {
      primary: "#E40037",
      primaryHover: "#000000",
    },
    logoImage: logo,
    backend: "https://billi.epaper-publishing-one.de/",
    directory: "/kiosk",
    header: {
      customer: "billi & friends Prospektwelt",
      title: "Aktuelle Angebote, Möbel & Wohninspiration",
      lineHeader: false,
      bannerColor: "#000000",
      fontColor: "#ffffff"
    },
    accToolbar: false,
    info: [
      {
        text: 'Impressum',
        link: 'https://billi-friends.de/informationen/impressum/'
      },
      {
        text: 'Datenschutz',
        link: 'https://billi-friends.de/informationen/datenschutz/'
      },
      {
        text: 'AGB',
        link: 'https://billi-friends.de/informationen/agb-kunden-info/'
      }
  ]
  };